// extracted by mini-css-extract-plugin
export default {"recentlyViewedListings":"recentlyViewedListings__MzVlM","noBorder":"noBorder__YzVlN"};